<script>
    import { createEventDispatcher, onMount } from "svelte";
    import backend from "../../../../server"
    import Select from 'svelte-select';


    //  ================= Const =================
    const LIST_GAMES = (params) => backend.games.list(params);
    const PAGE_SIZE  = 200;
    //  ================= Props =================
    export let brandOptions = [];
    export let initialBrand = "";
    export let initialSelected = [];
    export let selectionMode = "multiple"; // "single" | "multiple"
    export let onCloseEsc = true;
    export let provider = "";
    export let campaignType; // "SLOT" | "LIVE"
    export let campaign;
    export let betScalesLoading;
    export let betScalesTried;
    export let betScalesError;
    export let betScalesLoader;
    export let needGameAndCurrency;
    export let listGames = LIST_GAMES;
    export let codeClientSelect = '';
    export let betScales;
    export let formErrors = {};

    //  ================= Const and helpers =================
    const dispatch = createEventDispatcher();
    const TYPE_LABELS = { SLOT: 'Slots', LIVE: 'Slots Live' };
    const norm = s => (s ?? "").toString().normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();
    const toBrand = (b) => String(typeof b === 'object' ? b?.value : (b ?? ''));

    //  ================= Local variables =================
    let brandFilter = toBrand(initialBrand);
    let lastBrand = brandFilter;
    let query = "";
    let isLoading = false;
    let games = [];
    let gameConfigs = {};
    const gamesCache = new Map();
    let openDropdowns = null;
    let selected = new Set(initialSelected);
    let selectedByBrand = {};
    let selectedCount = 0;
    let brandNotice = "";
    let loadSeq = 0;
    let addedCount = 0;
    let initialized = false;
    //  ================= Reactive =================
    $: category = campaignType === 'SLOT' ? 'slot' : campaignType === 'LIVE' ? 'slot_live' : '';
    // Harmonized labels
    $: currentBrandLabel =
        (brandOptions || []).find(b => String(b.value) === String(brandFilter))?.label
        ?? String(brandFilter).replace(/[_-]+/g, ' ').trim();
    $: typeLabel = TYPE_LABELS[campaignType] ?? (category ? category.replace(/_/g,' ') : '');
    // Filtered games
    $: filtered = query ? games.filter(g => norm(g.label).includes(norm(query))) : games;
    $: allFilteredSelected = selectionMode === "multiple" && filtered.length > 0 && filtered.every(g => selected.has(g.value));
    $: selectedCount = selected.size;   
    $: canToggleSelect = selectionMode === "multiple" && filtered.length > 0;
    
    //  ================= Resets ================
    onMount(() => {
        brandFilter = toBrand(initialBrand);
        lastBrand = brandFilter;
        selected = new Set(initialSelected);
        if (brandFilter) {
            selectedByBrand[brandFilter] = new Set(initialSelected);
            loadByBrand(brandFilter);
        }
    });

    //  ================= Backend call's =================
    async function fetchGames({ clientCode, provider, brand, category }) {
        let page = 1, xpage = PAGE_SIZE, out = [];
        while (true) {
            const res = await listGames({
                clientCode,
                provider,
                brand,
                orderBy: "gameid",
                orderMode: "asc",
                ...(category ? { category } : {})
            });
            const rows = res?.data ?? [];
            for (const g of rows) {
                out.push({
                    value: g.gameid,
                    label: g.name || g.title || g.gameid
                });
            }
            break;
        }
        out.sort((a, b) => a.label.localeCompare(b.label, "es", { sensitivity: "base" }));
        return out;
    }
    async function loadByBrand(brand) {
        if (!brand) { games = []; return; }
        const cacheKey = `${provider}|${brand}|${category || ''}`;
        const clientCode = codeClientSelect || '';
        if (gamesCache.has(cacheKey)) {
            games = [...gamesCache.get(cacheKey)];
            const hasAny = games.length > 0;
            brandNotice = hasAny ? "" : `No existen juegos tipo ${typeLabel} para ${brand}.`;
            return;
        }
        const seq = ++loadSeq;
        isLoading = true;
        brandNotice = "";
        try {
            const list = await fetchGames({clientCode, provider, brand, category });
            if (seq !== loadSeq) return;
            gamesCache.set(cacheKey, list);
            games = [...list];
            const hasAny = list.length > 0;
            brandNotice = hasAny ? "" : `No existen juegos tipo ${typeLabel} para ${brand}.`;
            
        } catch (e) {
            console.error("Error cargando juegos:", e);
            if (seq !== loadSeq) return;
            games = [];
            brandNotice = `No existen juegos tipo ${typeLabel} para ${brand}.`;
        } finally {
            if (seq === loadSeq) isLoading = false;
        }
    }
    //  ================= Events =================
    function handleBrandChange() {
    if (!brandFilter) return;

    // NO tocamos selected aquí
    // NO lo vaciamos
    // NO lo cambiamos por marca

    if (brandFilter !== lastBrand) {
        loadByBrand(brandFilter);
        lastBrand = brandFilter;
    }
}


    function toggle(g) {
        if (selectionMode === "single") {
            if (selected.has(g.value)) selected.delete(g.value);
            else selected.add(g.value);
            selected = new Set(selected);
            return;
        }
        if (selected.has(g.value)) selected.delete(g.value);
        else selected.add(g.value);
        selected = new Set(selected);
    }
    function toggleDropdown(g) {
        if (openDropdowns === g.value) {
            openDropdowns = null;
            return;
        }
        openDropdowns = g.value;
        campaign.gameIdentifier = g.value;
        campaign.amount = "";
        campaign.rounds = "";
        dispatch("selectgame", {
            gameId: g.value
        });
    }
    function addGamesInList(gamesToAdd) {
        let amount = Number(campaign.amount);
        let rounds = Number(campaign.rounds);
        if (!(amount > 0)) {
            formErrors.amount = "El monto por giro debe ser > 0";
            formErrors = { ...formErrors };
            return;
        }
        if (!(Number.isInteger(rounds) && rounds >= 1)) {
            formErrors.rounds = "Las rondas deben ser un entero ≥ 1";
            formErrors = { ...formErrors };
            return;
        }
        for (const g of gamesToAdd) {
            selected.add(g.value);
            dispatch("addgameconfig", {
                gameId: g.value,
                gameName: g.label,
                brand: brandFilter,
                amountPerRound: amount,
                rounds: rounds
            });
        }
        selected = new Set(selected);
        openDropdowns = null;
    }


    function deleteGamesInList(gamesToDelete) {
        // if (!selectedByBrand[brandFilter]) {
        //     selectedByBrand[brandFilter] = new Set(selected);
        // }
        // const newSet = new Set(selected);
        for (const g of gamesToDelete) {
            // selectedByBrand[brandFilter].delete(g.value);
            selected.delete(g.value);
            dispatch("removegameconfig", {
                gameId: g.value
            });
        }
        // selected = newSet;
        selected = new Set(selected);
    }
    function clearError(keys) {
        // queueMicrotask(fetchBrandsFromAPI);
        const arr = Array.isArray(keys) ? keys : [keys];
        for (const k of arr) delete formErrors[k];
        formErrors = { ...formErrors }; 
    }
    function selectAllOrNone() {
        if (selectionMode !== "multiple") return;
        if (allFilteredSelected) {
            for (const g of filtered) selected.delete(g.value);
        } else {
            for (const g of filtered) selected.add(g.value);
        }
        selected = new Set(selected);
    }
    function confirm() {
        const result = Array.from(selected).map((gameId) => ({
            gameId,
            label: games.find(g => g.value === gameId)?.label || gameId,
            amount: gameConfigs[gameId]?.amount ?? 0,
            rounds: gameConfigs[gameId]?.rounds ?? 0
        }));
        dispatch("confirm", {
            brand: brandFilter,
            games: result
        });
    }
    function close() { dispatch("close"); }
    function handleKeydown(e) { if (onCloseEsc && e.key === "Escape") close(); }
</script>

<div class="modal d-block" tabindex="-1" on:keydown={handleKeydown} style="z-index: 1060;">
    <div class="modal-dialog modal-xl modal-dialog-centered fixed-modal">
        <div class="modal-content modal-fixed">
            <!-- Header -->
            <div class="modal-header">
                <h5 class="modal-title">Seleccionar juegos</h5>
                <button type="button" class="btn-close" on:click={close}></button>
            </div>
            <!-- Body -->
            <div class="modal-body modal-body-fixed">
                <div class="filters">
                    <div class="fcol">
                        <label for="brand" class="form-label mb-1">Marca</label>
                        <Select
                                items={brandOptions}
                                bind:value={brandFilter}
                                reduce={(it) => it?.value}
                                placeholder={brandOptions?.length ? '— Selecciona marca —' : 'Sin marcas disponibles'}
                                clearable={false}
                                inputId="brand"
                                disabled={!brandOptions?.length}
                                noOptionsMessage="Sin marcas disponibles"
                                on:select={() => {
                                brandFilter = toBrand(brandFilter);
                                handleBrandChange();
                                }}
                        class="form-control {brandFilter ? '' : 'select-placeholder'}"
                        />
                    </div>

                    <div class="fcol">
                        <label for="find_games" class="form-label mb-1">Buscar</label>
                        <input id="find_games" class="form-control" placeholder="Nombre del juego…" bind:value={query}/>
                    </div>

                    {#if selectionMode === "multiple"}
                        <div class="fcol end">
                            <label for="selectAll" class="form-label mb-1 invisible">.</label>
                            <button
                                    id="selectAll"
                                    class="btn btn-outline-secondary btn-sm"
                                    on:click={selectAllOrNone}
                                    disabled={!canToggleSelect}
                            >
                                {allFilteredSelected ? 'Deseleccionar todo' : 'Seleccionar todo'}
                            </button>
                        </div>
                    {/if}
                </div>

                <!-- Content -->
                {#if !brandFilter}
                    <div class="empty-block">Selecciona una marca para ver juegos.</div>
                {:else if isLoading}
                    <div class="empty-block">Cargando juegos…</div>
                {:else if filtered.length === 0}
                    <div class="empty-block">
                        {#if brandNotice}
                            {brandNotice}
                        {:else}
                            Sin resultados
                        {/if}
                    </div>
                {:else}
                <div class="game-list">
                        {#each filtered as g}
                            <label class="game-item {selected.has(g.value) ? 'disabled-item' : ''}" >
                                <!-- <button type="button" on:click={() => {toggleDropdown(g)}}>+</button> -->
                                <button 
                                    type="button"
                                    class:selected-added={selected.has(g.value)}
                                    on:click={() => {
                                        if (!selected.has(g.value)) {
                                            toggleDropdown(g);
                                        }
                                    }}
                                >
                                    {selected.has(g.value) ? '•' : '+'}
                                </button>

                                <span class="game-label">{g.label}</span>  
                                {#if openDropdowns === g.value && !selected.has(g.value)}
                                    <button type="button" class="btn btn-outline-secondary btn-sm" disabled={!campaign.amount && !campaign.rounds} on:click={() => {addGamesInList([g])}}>Añadir</button>

                                {:else if selected.has(g.value)}
                                    <span>Añadido</span>
                                    <button type="button" class="btn btn-outline-secondary btn-sm" disabled={!campaign.amount && !campaign.rounds} on:click={() => {deleteGamesInList([g])}}>Eliminar</button>

                                <!-- {:else if !selected.has(g.value)} -->
                                <!-- -->
                                {/if}
                            
                            </label>
                            {#if openDropdowns === g.value}
                            <div class="dropdown modal-grid">
                                {#if campaignType === 'SLOT'}
                                <div>
                                    <label for="amount" class="form-label">Monto por giro</label>
                                    {#if betScalesLoader}
                                        {#if betScalesLoading}
                                            <div class="form-text">Cargando montos disponibles…</div>
                                        {:else if betScalesError}
                                            <input id="amount" type="number" min="0"
                                                   class="form-control {formErrors.amount ? 'is-invalid' : ''}"
                                                   bind:value={campaign.amount}
                                                   disabled
                                            />
                                            <small class="text-danger d-block mt-1">{betScalesError}</small>
                                        {:else if betScales.length}
                                            <select id="amount"
                                                    class="form-control {formErrors.amount ? 'is-invalid' : ''} {needGameAndCurrency ? 'readonly-style' : ''}"
                                                    bind:value={campaign.amount}
                                                    disabled={needGameAndCurrency}
                                                    on:change={() => clearError("amount")}
                                            >
                                                <option value="" disabled selected={campaign.amount === ""}>
                                                    {(!campaign.gameIdentifier || !campaign.currency) ? 'Selecciona juego y moneda' : 'Selecciona un monto'}
                                                </option>
                                                {#each betScales as v}
                                                    <option value={v}>{v}</option>
                                                {/each}
                                            </select>
                                        {:else if betScalesTried}
                                            <input id="amount" type="number" min="0"
                                                   class="form-control {formErrors.amount ? 'is-invalid' : ''}"
                                                   bind:value={campaign.amount} on:input={() => clearError("amount")}/>
                                            <div class="form-text">No hay montos predefinidos para este juego/moneda.
                                            </div>
                                        {:else}
                                            <select id="amount" class="form-control readonly-style" disabled>
                                                <option>{(!campaign.gameIdentifier || !campaign.currency) ? 'Selecciona juego y moneda' : 'Cargando montos...'}</option>
                                            </select>
                                        {/if}
                                    {:else}
                                        <input id="amount" type="number" min="0"
                                               class="form-control {formErrors.amount ? 'is-invalid' : ''}"
                                               bind:value={campaign.amount}
                                               on:input={() => clearError("amount")}
                                        />
                                    {/if}
                                    {#if formErrors.amount}<small class="text-danger">{formErrors.amount}</small>{/if}
                                </div>
                                <div>
                                    <label for="rounds" class="form-label">Rondas</label>
                                    <input id="rounds" type="number" min="1"
                                           class="form-control {formErrors.rounds ? 'is-invalid' : ''}"
                                           bind:value={campaign.rounds}
                                           on:input={() => clearError("rounds")}
                                    />
                                    {#if formErrors.rounds}<small class="text-danger">{formErrors.rounds}</small>{/if}
                                </div>
                                {/if}
                            </div>
                            {/if}
                        {/each}
                    </div>
                {/if}
            </div>

            <!-- Footer -->
            <div class="modal-footer sticky-footer">
                <div class="me-auto small text-muted">Seleccionados: {selectedCount}</div>
                <div>Agregados: {addedCount}</div>
                <button class="btn btn-secondary btn-sm" on:click={close}>Cancelar</button>
                <button class="btn btn-primary btn-sm" on:click={confirm} disabled={!selectedCount || !brandFilter}>
                    Guardar
                </button>
            </div>
        </div>
    </div>
</div>

<style>
    .fixed-modal { max-width: 900px; }
    .modal-grid { display:grid; grid-template-columns: repeat(2, 1fr); gap:1rem; padding:1.5rem 2.5rem; background:#e9ecef;}
    .modal-fixed { height: 80vh; display: flex; flex-direction: column; }
    .modal-header { flex: 0 0 auto; }
    .modal-body-fixed { flex: 1 1 auto; min-height: 0; display: flex; flex-direction: column; }
    .modal-footer.sticky-footer {
        flex: 0 0 auto;
        position: sticky;
        bottom: 0;
        background: #fff;
        z-index: 1;
        border-top: 1px solid var(--bs-border-color, #e5e7eb);
    }
    .filters {
        display: grid;
        grid-template-columns: 1fr 1fr auto;
        gap: .75rem;
        margin-bottom: .75rem;
    }
    .fcol.end { display: flex; align-items: end; }
    .empty-block {
        flex: 1; display: grid; place-items: center;
        border: 1px dashed #ddd; border-radius: 10px; color: #777;
    }
    .game-list {
        flex: 1; overflow: auto;
        border: 1px solid var(--bs-border-color, #e5e7eb);
        border-radius: 10px; padding: .5rem; background: #fff;
    }
    .game-item {
        display: flex; align-items: center; gap: .5rem;
        padding: .35rem .5rem; border-radius: 6px; cursor: pointer;
    }
    .game-item:hover { background: #f7f7f7; }
    .game-label { flex: 1; }
    .invisible { visibility: hidden; }
    .disabled-item {
        background: #f0f0f0 !important;
        opacity: 0.75;
        pointer-events: auto; /* el item sí permite eliminar */
    }
    button[selected-added] {
        opacity: 0.4;
        cursor: not-allowed;
    }
</style>